<template>
    <modal
            :linkClass="'action-icon'"
            :modalId="name"
            :title="title"
            :modalSize="'large'"
            :footer="true"
    >
        <template slot="modalBody">
            <form>
                <div class="row">
                    <div class="form-group col-6">
                        <label for="sickLeave-startDate">Begin datum</label>
                        <datepicker
                                :language="nl"
                                id="sickLeave-startDate"
                                v-model="value.startDate"
                                :fullMonthName="true"
                                format="dd-MM-yyyy"
                                input-class="form-control"
                                :calendar-button="true"
                                :calendar-button-icon="'far fa-calendar-alt'"
                                :class="{ 'is-invalid': errors.has('date') }"
                                :disabled-dates="disabledStartDates"
                        ></datepicker>
                    </div>
                    <div class="form-group col-6">
                        <label for="sickLeave-endDate">Einddatum</label>
                        <datepicker
                                :language="nl"
                                id="sickLeave-endDate"
                                v-model="value.endDate"
                                :fullMonthName="true"
                                format="dd-MM-yyyy"
                                input-class="form-control"
                                :calendar-button="true"
                                :calendar-button-icon="'far fa-calendar-alt'"
                                :clear-button="true"
                                :clear-button-icon="'far fa-times'"
                                :class="{ 'is-invalid': errors.has('date') }"
                                :disabled-dates="disabledEndDates"
                        ></datepicker>
                    </div>
                </div>
            </form>
        </template>

        <div class="modal-footer" slot="modalFooter">
            <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">Annuleren</button>
            <button type="button" class="btn btn-primary" @click="saveSickDates">
                <i class="fal fa-save mr-2"></i> Opslaan
            </button>
        </div>
    </modal>
</template>

<script>
    import Datepicker from "vuejs-datepicker";
    import {nl} from "vuejs-datepicker/dist/locale";

    export default {
        props: ["title", "value", "name"],
        components: {
            Datepicker
        },
        data() {
            return {
                nl: nl,
            };
        },
        methods: {
            saveSickDates() {

                this.$emit('saveChanges', this.value);
                $('.modal').modal('hide') ;
                $('.modal-backdrop').remove();


                this.value.startDate = null;
                this.value.endDate = null;
            }
        },
        computed: {
            disabledEndDates() {
                return {
                    to: new Date(this.value.startDate),
                    ranges: this.disabledDates
                }
            },
            disabledStartDates() {
                if (this.value.endDate !== null) {
                    return {
                        from: new Date(this.value.endDate),
                        ranges: this.disabledDates
                    }
                } else {
                    return {
                        ranges: this.disabledDates
                    }
                }
            },

            disabledDates() {
                let ranges = []
                // Push every date into from, to in the range array
                _.each(this.sickDays, (dates) => {
                    ranges.push(
                            {
                                from: new Date(dates.startDate),
                                to: new Date(dates.endDate)
                            })
                })

                return ranges

            },
        },
    };
</script>
